import PropTypes from 'prop-types';

export default function StatCard({ icon: Icon, label, value, change, changeType = 'positive', variant, details }) {
    const variantClasses = {
        primary: "bg-[#e5f4f2] text-[#099889]",
        accent: "bg-[#fff4e5] text-[#ffb547]",
        destructive: "bg-[#e5f4f2] text-[#099889]",
        success: "bg-[#e5f4f2] text-[#099889]",
    };
    return (
        <div className="bg-white rounded-lg p-3 shadow-sm border-0 hover:shadow-md transition-shadow duration-300 animate-slide-up">
            <div className="flex items-start justify-between">
                <div className="flex-1 space-y-1">
                    <p className="text-sm text-[#77848f] font-medium">{label}</p>
                    <h3 className="text-3xl font-bold text-gray-900">{value}</h3>
                    {/* {change && (
                        <p className={`text-xs font-medium ${changeType === 'positive' ? 'text-green-600' : 'text-red-600'}`}>
                            {changeType === 'positive' ? '+' : ''}{change}
                        </p>
                    )} */}
                    {details && (
                        <p className="text-xs text-[#019586] font-medium">
                            {details}
                        </p>
                    )}
                </div>
                {Icon && (
                    <div className={`p-2 rounded-xl ${variantClasses[variant] || variantClasses.primary}`}>
                        <Icon className="w-5 h-5" />
                    </div>
                )}
            </div>
        </div>
    );
}

StatCard.propTypes = {
    icon: PropTypes.elementType,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    change: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    changeType: PropTypes.oneOf(['positive', 'negative', 'neutral']),
    variant: PropTypes.oneOf(['primary', 'accent', 'destructive', 'success']),
    details: PropTypes.string,
};

StatCard.defaultProps = {
    changeType: 'positive',
    variant: 'primary',
};
